import { Inertia } from "@inertiajs/inertia";
import { InertiaApp } from "@inertiajs/inertia-react";
import NProgress from "nprogress";
import { render } from "react-dom";

Inertia.on("navigate", (event) => {
	// // console.log(`Navigated to page: ${event.detail.page.url}`);
	// const { visit } = event.detail;

	// // Don't scroll for back/forward navigation
	// if (visit.history === "back" || visit.history === "forward") {
	// 	return;
	// }

	// // Scroll to top for all other navigation
	// if (!visit.preserveScroll) {
	// 	window.scrollTo(0, 0);
	// }
	gtag("event", "page_view", {
		page_location: event.detail.page.url,
	});

	window.scrollTo({
		top: 0,
		behavior: "smooth", // Optional: adds smooth scrolling
	});
});

// InertiaProgress.init({
// 	// The color of the progress bar.
// 	color: "rgba(255, 0, 0)",
// 	// Whether the NProgress spinner will be shown.
// 	showSpinner: true,
// });

Inertia.on("start", ({ detail: { visit } }) => {
	// console.log(visit, window.location.href);
	if (visit.hasOwnProperty("only") && visit.only.includes("noProgress")) {
	} else {
		NProgress.start();
	}
});

Inertia.on("finish", (event) => {
	if (event.detail.visit.completed) {
		NProgress.done();
	} else if (event.detail.visit.interrupted) {
		NProgress.set(0);
	} else if (event.detail.visit.cancelled) {
		NProgress.done();
		NProgress.remove();
	}
});

const app = document.getElementById("app");

if (process.env.NODE_ENV !== "development") {
	// disable react-dev-tools for this project
	if (typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === "object") {
		for (let [key, value] of Object.entries(window.__REACT_DEVTOOLS_GLOBAL_HOOK__)) {
			window.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] = typeof value == "function" ? () => {} : null;
		}
	}
}

render(
	<InertiaApp
		initialPage={JSON.parse(app.dataset.page)} //
		resolveComponent={(name) => import(`./Pages/${name}`).then((module) => module.default)}
	/>,
	app
);
